export default "__VITE_ASSET__CsYLYGZO__"